export default "__VITE_ASSET__D4A$15$I__";